module.exports = __webpack_public_path__ + "case.png?c14d85044a001cd77b689dc8e7e6204d";